import { useState, useEffect } from "react";
import { dbURL } from "./global";

async function getTableItems() {
  // Send credentials by post
  const response = await fetch(dbURL + "getTableItems.php", {
    method: "POST",
    body: JSON.stringify({
      table: "errordata_definitions", // specify the definitions table
    }),
    credentials: "include",
  });
  const result = await response.json();
  // Set the login variables

  return result;
}

function UseTableItems() {
  const [tableItems, setTableItems] = useState([]);
  useEffect(() => {
    getTableItems().then((items) => {
      setTableItems(items);
    });
  }, []);

  return tableItems;
}

/*
const TableItems = [
    {
        "id": "id",
        "textFull": "Numer",
        "textLong": "Lp.",
        "textShort": "Nr",
        "dataItem": "ID"
    },
    {
        "id": "doctype",
        "textFull": "Rodzaj dokumentu sprzedaży",
        "textLong": "Dokument",
        "textShort": "Rodzaj dok. sprz.",
        "dataItem": "DocType"
    },
    {
        "id": "docnumber",
        "textFull": "Numer dokumentu sprzedaży",
        "textLong": "Nr dokumentu",
        "textShort": "Nr dok. sprz.",
        "dataItem": "DocNumber"
    },
    {
        "id": "problemorerror",
        "textFull": "Problem / błąd pracownika",
        "textLong": "Rodzaj",
        "textShort": "Rodzaj",
        "dataItem": "ProblemOrError"
    },
    {
        "id": "employeeinvolved",
        "textFull": "Pracownik związany z błędem lub problemem",
        "textLong": "Pracownik powiązany",
        "textShort": "Pracownik powiązany",
        "dataItem": "EmployeeInvolved"
    },
    {
        "id": "description",
        "textFull": "Dokładny opis sytuacji",
        "textLong": "Opis sytuacji",
        "textShort": "Opis sytuacji",
        "dataItem": "Description"
    },
    {
        "id": "datereportedbymanager",
        "textFull": "Zgłoszony przez kierownika recepcji do K. Jasieczek e-mailem dnia:",
        "textLong": "Zgłoszony dnia",
        "textShort": "Zgłoszony dnia",
        "dataItem": "DateReportedByManager"
    },
    {
        "id": "approvedsolution",
        "textFull": "Rozwiązanie zatwierdzone przez K. Jasieczek",
        "textLong": "Rozwiązanie",
        "textShort": "Zatwierdzone KJ",
        "dataItem": "ApprovedSolution"
    },
    {
        "id": "datedone",
        "textFull": "Zrealizowano przez kierownika recepcji",
        "textLong": "Data realizacji",
        "textShort": "Data realizacji",
        "dataItem": "DateDone"
    },
]*/

export default UseTableItems;
